export class FilterEvent {
  F: boolean = true;
  W: boolean = true;
  I: boolean = true;
  D: boolean = true;
  IH: boolean = true;
}
